// exports.baseURL = process.env.REACT_APP_BACKEND_BASE_URL;
// exports.key = process.env.REACT_APP_KEY;

exports.baseURL = "https://flirzaultimate.codestorehub.cloud/";
exports.key = "vguikkOUno8Xcfvjhkiyb06aIKrejZ9R4h";

// 5038
